// Converts a date picked in a local IANA timezone into the UTC calendar date
// that the passkey hash must be computed against. The passkey is derived purely
// from a UTC date (see api/lib/passkey.mjs), so local midnight on the picked date
// has to be resolved to UTC *before* the date string is sent to the API. For
// positive UTC offsets (e.g. JST, UTC+9) this rolls the date back by one day;
// for UTC/negative offsets the date is usually unchanged.
export function getUTCDateForLocalMidnight(localDate, timeZone) {
  const [year, month, day] = localDate.split("-").map(Number);
  const localMidnightAsUTC = Date.UTC(year, month - 1, day);

  const offsetFormatter = new Intl.DateTimeFormat("en-US", {
    timeZone,
    timeZoneName: "shortOffset",
  });
  const offsetName = offsetFormatter
    .formatToParts(localMidnightAsUTC)
    .find(part => part.type === "timeZoneName")?.value || "GMT";

  const [, sign, hours, minutes] = offsetName.match(/GMT([+-]?)(\d+)(?::(\d+))?/) || [null, "+", "0", "0"];
  const offsetMinutes = (sign === "-" ? -1 : 1) * (Number(hours) * 60 + Number(minutes || 0));

  const utcInstant = new Date(localMidnightAsUTC - offsetMinutes * 60 * 1000);
  return utcInstant.toISOString().slice(0, 10);
}
